<template>
  <div>
    <div class="air__utils__heading">
      <div class="d-flex justify-content-between">
        <h5>Estabelecimento</h5>
      </div>
    </div>

    <template v-if="loading">
      <a-skeleton active />
    </template>

    <template v-else>
      <a-tabs default-active-key="1" v-model="activeKey">
        <a-tab-pane key="1" tab="Empresa">
          <form-merchant
            ref="formmerchant"
            v-model="merchantForm"
            :merchant="merchant"
            class="mt-2"
          ></form-merchant>
        </a-tab-pane>
        <a-tab-pane
          key="2"
          :disabled="hasDisabled('config')"
          tab="Configurações"
        >
          <form-merchant-config
            :merchant="merchant"
            class="mt-2"
          ></form-merchant-config>
        </a-tab-pane>
        <a-tab-pane key="3" :disabled="hasDisabled('merchantTax')" tab="Taxas">
          <form-merchant-tax
            :merchantTax="merchantTax"
            class="mt-2"
          ></form-merchant-tax>
        </a-tab-pane>
        <a-tab-pane
          key="6"
          :disabled="hasDisabled('merchantCommissioning')"
          tab="Comissionamento"
        >
          <form-merchant-commissioning
            :merchant="merchant"
            class="mt-2"
          ></form-merchant-commissioning>
        </a-tab-pane>
        <a-tab-pane
          key="4"
          :disabled="hasDisabled('merchantFiles')"
          tab="Arquivos"
        >
          <form-files
            :merchantFiles="merchantFiles"
            :idMerchant="idMerchant"
            class="mt-2"
          ></form-files>
        </a-tab-pane>
        <a-tab-pane
          key="5"
          :disabled="hasDisabled('merchantManager')"
          tab="Representante"
        >
          <form-representative
            :merchantRepresentative="merchantRepresentative"
            :merchant="merchantForm"
            class="mt-2"
          ></form-representative>
        </a-tab-pane>
        <a-tab-pane
          key="7"
          :disabled="hasDisabled('merchantDevices')"
          tab="Equipamentos"
        >
          <form-merchant-devices
            :idMerchant="idMerchant"
            class="mt-2"
          />
        </a-tab-pane>
      </a-tabs>
    </template>
  </div>
</template>

<script>
import FormMerchant from "./steps/form-merchant";
import FormMerchantConfig from "./steps/form-config";
import FormMerchantCommissioning from "./steps/form-commissioning";
import FormMerchantTax from "./steps/form-merchant-tax";
import FormMerchantDevices from "./steps/form-merchant-devices";
import FormRepresentative from "./steps/form-representative";
import FormFiles from "./steps/form-files/index";
import { MerchantsResource } from "@/resources/Merchants.resource.js";

export default {
  components: {
    FormMerchant,
    FormMerchantConfig,
    FormMerchantCommissioning,
    FormRepresentative,
    FormFiles,
    FormMerchantTax,
    FormMerchantDevices,
  },
  data() {
    return {
      loading: false,
      activeKey: "1",
      idMerchant: 0,
      merchant: {},
      merchantForm: {},
      merchantConfig: {},
      merchantTax: {},
      merchantFiles: {},
      merchantRepresentative: {},
      commissioning: {},
    };
  },

  watch: {
    $route() {
      this.idMerchant = this.$route.params.id;
    },
  },

  created() {
    if (this.$route.params.id > 0) {
      this.idMerchant = this.$route.params.id;
      this.loadMerchant();
    }
  },

  computed:{
  sysAdminUser() {
      try {
        return (
          this.$store.getters.user.role
            .split(",")
            .filter((role) => role === "SystemAdmin").length > 0
        );
      } catch (e) {
        return false;
      }
    },
  },

  methods: {
    hasDisabled(tabName) {
      // first rule
      if (this.idMerchant === 0) return true;

      // has sysAdmin returns false
      if(this.sysAdminUser) return false;

      const roles = this.$store.getters.user.role.split(",");
      let result = false;
      // hierarchicaly rules
      switch (tabName) {
        case "config": {
          result =
            roles.filter((role) => {
              return (
                 role == "SysAdmin" || role == "SaleChannel" || role == "Operator" ||  role == "Finance"
              );
            }).length == 0;

          break;
        }
        case "merchantTax": {
          let merchantdisabled = true;
          merchantdisabled &=
            roles.filter((role) => {
              return (
                role === "SysAdmin" ||
                role === "SaleChannel"
                || role == "Operator" ||  role == "Finance"
              );
            }).length === 0;
          result = merchantdisabled;
          break;
        }
        case "merchantCommissioning": {
          let merchantCommissioningdisabled = true;
          merchantCommissioningdisabled &=
            roles.filter((role) => {
              return (
                role === "SysAdmin" ||
                role === "SaleChannel"
                || role == "Operator" ||  role == "Finance"
              );
            }).length === 0;
          result = merchantCommissioningdisabled;
          break;
        }
        case "merchantDevices": {
          let merchantDevicesDisabled = true;
          merchantDevicesDisabled &=
            roles.filter((role) => {
              return (
                role === "Manager" ||
                role === "SysAdmin" ||
                role === "SaleChannel"
                || role == "Operator" ||  role == "Finance"
              );
            }).length === 0;
          result = merchantDevicesDisabled;
          break;
        }
      }

      return !!result;
    },
    loadMerchant() {
      this.loading = true;
      MerchantsResource.getMerchantWithBank({ idMerchant: this.idMerchant })
        .then((result) => {
          try {
            this.merchant = result.data.payload;
            this.loading = false;
          } catch (e) {
            throw {
              response: {
                data: {
                  failureReason: "Deu ruim na chamada...",
                },
              },
            };
          }
        })
        .catch((e) => {
          this.loading = false;
        });
    },
  },

  mounted() {},
};
</script>
